import { Component, OnInit } from '@angular/core';
import { ReportCode } from '@classes/report/report-code';
import { ReportService } from '@services/report.service';

@Component({
  selector: 'app-report-system',
  templateUrl: './report-system.component.html',
  styleUrls: ['./report-system.component.scss']
})
export class ReportSystemComponent implements OnInit {
    isGenerating: boolean;
    selectedReport: ReportCode;
    reportCodes: ReportCode[];

    constructor(private reportSrv: ReportService) {}

    ngOnInit(): void {
        this.reportSrv
            .getXlsSystemCodes()
            .subscribe(codes =>
            {
                this.reportCodes = codes;
                if (codes.length > 0)
                    this.selectedReport = codes[0];
            });
    }

    onExportReport(): void {
        this.isGenerating = true;

        this.reportSrv
            .generateXlsSystem(this.selectedReport)
            .subscribe(() => this.isGenerating = false);
    }
}
